import { RootState } from '@/store';

export const newMessagesCountSelector = (state: RootState) => {
  return state.chatStore.newMessagesCount;
};
